import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.viewDocument || initialState;

export const selectViewDocument = createSelector([selectSlice], state => state);
